import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ButtonComponent from "../../../components/common/button/Button";
import { DateComparator } from '../../../components/common/DateComparator';
import { DaysComparator } from '../../../components/common/DaysComparator';

export const DPSPlannerColumnHeader = (navigate, handleOpenViewAllModal) => {
    return [
        { field: "supplierId", headerName: "Supplier" },
        {
            field: "materialId", headerName: "Material",
            cellRenderer: (response) => {
                return (
                    <span><a href={`${process.env.REACT_APP_SAP_FIORI_MATERIAL_MASTER_DISPLAY_BASE_URL}?sap-client=010&sap-language=EN#Material-display?Material=${response?.value}`} target="_blank" style={{ color: '#000', cursor: 'pointer' }}>{response?.value || "-"}</a></span>
                )
            }
        },
        { field: "purchasingGroup", headerName: "Purchasing Group" },
        { field: "inventoryClass", headerName: "Inventory Classification" },
        { field: "purchDocType", headerName: "Purchasing Document Type" },
        { field: "shipTo", headerName: "Ship To City" },
        { field: "shipToCountry", headerName: "Ship To Country" },
        { field: "incoterm", headerName: "Incoterm" },
        {
            field: "demonstratedLt", headerName: "Demonstrated Lead Time",
            comparator: DaysComparator,
            cellRenderer: (response) => {
                // Combine two objects
                const combinedObject = {
                    data: response.data,
                };

                return (
                    <div>
                        {" "}
                        <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => navigate('/DPS-Planner-analytics-Details', { state: { combinedObject } })} >{response.value}</span>
                    </div>
                )
            }
        },
        // { field: "confidenceScore", headerName: "Confidence Score" },
        { field: "ltInitiatedBy", headerName: "Analytics Initiated by" },
        {
            field: "updatedAt", headerName: "Results Updated at",
            comparator: DateComparator,
            // filter: 'agDateColumnFilter',
        },
        { field: "runOutputSeqId", headerName: "ID" },
        {
            field: "View Input Details",
            width: 120,
            cellRenderer: (response) => (
                <div className="btn-wrapper">
                    {" "}
                    {/* <LeadtimeModel data={response.data} /> */}
                    <ButtonComponent type="secondary" label="Input" onClick={() => handleOpenViewAllModal(response.data)} endIcon={<ArrowForwardIosIcon style={{ fontSize: 12 }} />} />

                </div>
            ),
            pinned: "right",
            lockPinned: true,
        },
    ]
}

